export const entitiesClass = {
  place: 'Place',
  person: 'Person',
  organization: 'Organization',
  event: 'Event',
  people: 'People',
  user: 'User',
};

export const REPORT_ACTION_KEY = 'generate-report';
export const DATABASE_ACTION_KEY = 'download-db';
export const IMPORT_ACTION_KEY = 'import';
